import { IResult } from '~src/httpClient/serverApi/types/IResponse';

import { Request } from '../../httpClient/serverApi/requests/Request';

export interface IShouldShowIdentityMigrationInfoToastParams {
}

export class ShouldShowIdentityMigrationInfoToastRequest extends Request<IShouldShowIdentityMigrationInfoToastParams, IResult> {
  constructor(params: IShouldShowIdentityMigrationInfoToastParams = {}) {
    super('shouldShowIdentityMigrationInfoToast', params);
  }
}
